import Table from './components/Table'

const index = () => {
  return (
    <>
      <Table/>
    </>
  )
}

export default index
